import { APIConfig, apiConfigEqual } from "../API";
import * as LocalStore from "../LocalStore";

import ons from "onsenui";
import * as React from "react";

interface APINotProductionAlertProps {
  apiConfig: APIConfig;
}

export class APINotProductionAlert extends React.Component<APINotProductionAlertProps, {}> {
  handleClick() {
    ons.notification
      .alert({
        animation: "none",
        modifier: "material",
        title: "Current API Server",
        message: "Url: " + this.props.apiConfig.apiBaseUrl,
        cancelable: true,
      })
      .then(
        () => {
          /* Do Nothing */
        },
        () => {
          /* Do Nothing */
        }
      );
  }

  render() {
    return (
      <div
        style={{
          display: apiConfigEqual(this.props.apiConfig, LocalStore.productionApiConfig)
            ? "none"
            : "",
          position: "absolute",
          right: "0",
          top: "0",
          fontSize: "20px",
          color: "#000",
          zIndex: 9000, // Please see the document CSS-z-index.md
          background: "yellow",
        }}
        onClick={() => this.handleClick()}
      >
        (!)
      </div>
    );
  }
}
